import ApplicationController from "./application_controller"

// User banner/profile image upload -- same UserImagesController#create/#update backend as
// the legacy Jcrop flow, no crop tool (Jcrop is jQuery). Root-level so it's reusable.
export default class extends ApplicationController {
  static targets = ["placeholder", "previewWrapper", "preview", "input", "saveButton", "changeButton"]
  static values = {
    url: String,
    exists: Boolean,
    existingId: String,
    fieldName: String
  }

  openPicker(event) {
    event.preventDefault()
    this.inputTarget.click()
  }

  fileSelected(event) {
    const file = event.target.files[0]
    if (!file) return

    this.previewTarget.src = URL.createObjectURL(file)
    this.previewWrapperTarget.classList.remove("d-none")
    this.placeholderTarget.classList.add("d-none")
    this.changeButtonTarget.classList.remove("d-none")
    this.saveButtonTarget.disabled = false
  }

  save(event) {
    event.preventDefault()
    const file = this.inputTarget.files[0]
    if (!file) return

    const formData = new FormData()
    formData.append("user_image[image]", file)
    formData.append("user_image[field_name]", this.fieldNameValue)
    if (this.existsValue) formData.append("user_image[id]", this.existingIdValue)

    const token = document.querySelector('meta[name="csrf-token"]')
    const originalText = this.saveButtonTarget.textContent
    this.saveButtonTarget.disabled = true
    this.saveButtonTarget.textContent = "UPLOADING..."
    this.setBusy(true)

    fetch(this.urlValue, {
      method: this.existsValue ? "PATCH" : "POST",
      body: formData,
      headers: {
        "X-Requested-With": "XMLHttpRequest",
        "Accept": "application/json", // without this Rails falls back to the HTML branch, which redirects to request.referrer
        "X-CSRF-Token": token ? token.content : ""
      }
    })
      .then((response) => {
        if (!response.ok) throw new Error(`HTTP ${response.status}`)
        this.setBusy(false)
        window.Gv3Toast.success("Image uploaded successfully.")
        setTimeout(() => window.location.reload(), 900) // let the toast be visible before the reload wipes it
      })
      .catch(() => {
        this.setBusy(false)
        this.saveButtonTarget.disabled = false
        this.saveButtonTarget.textContent = originalText
        window.Gv3Toast.error("The image could not be uploaded. Please try again.")
      })
  }

  setBusy(isBusy) {
    const loader = document.getElementById("global-ajax-loader")
    if (loader) loader.classList.toggle("d-none", !isBusy)
  }
}
